import { render, staticRenderFns } from "./GameSpell.vue?vue&type=template&id=d552c790&scoped=true&"
import script from "./GameSpell.vue?vue&type=script&lang=js&"
export * from "./GameSpell.vue?vue&type=script&lang=js&"
import style0 from "./GameSpell.vue?vue&type=style&index=0&id=d552c790&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d552c790",
  null
  
)

export default component.exports